"use client"
import React, { useEffect, useState } from "react";
import useIsHydrated from "src/lib/client/useIsHydrated";
import type { ProgramFilterStateType } from "src/lib/contexts/ContextTypes";
import { PROGRAM_FILTER_EMPTY_STATE, ProgramFilterContext } from "src/lib/contexts/ContextTypes";
import { parseProgramHash, updateProgramHash } from "src/lib/programHash";

//#region [Other]



//#endregion

//#region [Props]
type ProgramFilterWrapperProps = {
    children: React.ReactNode;
};
//#endregion

//#region [Component]
export default function ProgramFilterWrapper({ children }: ProgramFilterWrapperProps) {
    const [filterState, setFilterState] = useState<ProgramFilterStateType>(PROGRAM_FILTER_EMPTY_STATE);

    // The hash is only known in the browser, so it's read in the first render after hydration
    // to avoid a hydration mismatch (e.g. the family checkbox being checked on the client only)
    const isHydrated = useIsHydrated();
    const [isRestoredFromHash, setIsRestoredFromHash] = useState(false);
    if (isHydrated && !isRestoredFromHash) {
        setIsRestoredFromHash(true);
        const { genres } = parseProgramHash(window.location.hash);
        if (genres) {
            setFilterState((oldState) => ({ ...oldState, genres }));
        }
    }

    useEffect(() => {
        // not before the hash is read - writing the initial empty filter would wipe it
        if (!isRestoredFromHash) {
            return;
        }
        updateProgramHash({ genres: filterState.genres });
    }, [filterState.genres, isRestoredFromHash]);

    /*
    useWhatChanged(
        [filterState.genres, filterState.highlightKinoklubb, filterState.highlightPremieres, filterState.perspective, filterState.timeIntervals],
        "genres, highlightKinoklubb, highlightPremieres, perspective, timeIntervals",
        "filterState");
        */
    return <ProgramFilterContext.Provider value={{
        ...filterState,
        reset: () => setFilterState(PROGRAM_FILTER_EMPTY_STATE),
        applyFilter: (newFilter: ProgramFilterStateType) => {
            console.debug("Applying new filter", newFilter);
            setFilterState((oldState) => ({ ...oldState, ...newFilter }));
        },
    }}>
        {children}
    </ProgramFilterContext.Provider>;
}
//#endregion
